import ReactDOM from 'react-dom';
import 'antd/dist/reset.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider, Empty } from 'antd';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import store from './@redux/store';
import theme, { antTheme } from './configs/theme';
import AppWrapper, { GlobalStyle } from './appStyle';
import Routes from './routes';
import * as serviceWorker from './serviceWorker';

import { initFirebase } from './api/firebase';

initFirebase();

// Suppress ResizeObserver loop warning (harmless - common with Ant Design)
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

// Suppress ResizeObserver loop limit exceeded error
const originalWarn = console.warn;
console.warn = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop limit exceeded')
  ) {
    return;
  }
  originalWarn.call(console, ...args);
};

// Suppress ResizeObserver errors via window error handler
const originalErrorHandler = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (
    typeof message === 'string' &&
    message.includes('ResizeObserver loop')
  ) {
    return true; // Suppress the error
  }
  if (originalErrorHandler) {
    return originalErrorHandler(message, source, lineno, colno, error);
  }
  return false;
};

// Also handle unhandled promise rejections that might include ResizeObserver errors
window.addEventListener('error', (event) => {
  if (
    event.message &&
    typeof event.message === 'string' &&
    event.message.includes('ResizeObserver loop')
  ) {
    event.preventDefault();
    event.stopPropagation();
  }
});
ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <AppWrapper>
          <GlobalStyle />
          <ConfigProvider theme={antTheme} renderEmpty={() => <Empty />}>
            <Routes />
          </ConfigProvider>
        </AppWrapper>
      </ThemeProvider>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
